/* eslint-disable no-nested-ternary */

import React, { useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ImageItem from './SingleImagePreview';
import uploadIcon from 'img/Upload_file.png';

import NxtCircularLoader from 'components/nxt_circular_loader/View'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  imageContainer: {
    position: 'relative',
    width: '97px',
  },
  relativeimgbox:{
    position: 'relative',
    display: 'inline-block',
    margin:'10px 0'
  },
  img: {
    display: 'block',
    overflow: 'hidden',
    width: '97px',
    height: '97px',
    borderRadius: '10px',
  },
  deleteButton: {
    position: 'absolute',
    right: -5,
    top: -5,
    height: '20px',
    width: '20px',
    cursor: 'pointer',
  },

  input: {
    display: 'none',
  },
  
  button: {
    width: '100%',
  },
  error: {
    color: theme.palette.error.main,
  },
  stepperRoot: {
    float: 'right',
    width: '484px',
  },
  radioButtonMain: {
    paddingLeft: theme.spacing(1.5),
  },
  add_image: {
    width: '280px',
    height: '120px',
    border: '1px dashed #666666',
    borderRadius: '10px',
    cursor: 'pointer',
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@media(max-width:767px)':{
      width:'100%'
    }
  },
  upload_icon: {
    width: '62px',
    height: '62px',
    padding: '2px',
  },
  upload_media_help_text_1: {
    fontFamily: 'VodafoneRg-Bold',
    color: '#6551FF',
    fontSize: '14px',
    padding: '2px',
  },
  dragndrop_text:{
    fontFamily: 'VodafoneRg-Regular',
    color: '#333333',
    fontSize: '16px',
    paddingTop: '6px',
  },
  format_support_text: {
    fontFamily: 'VodafoneRg-Regular',
    color: '#999999',
    fontSize: '14px',
    paddingTop: '6px',
    paddingBottom: '15px',
  },
  image_grid: {
    display: 'grid', 
    gridTemplateColumns: '1fr 1fr 1fr', 
    columnGap: '25px',
    rowGap: '25px',
  },
  image_name: {
    fontSize: '16px',
    fontFamily: 'VodafoneRg-Regular',
    color: '#333333',
    paddingTop: '7px',
  },
  imageUploadDisabled:{
    cursor:'default',
    'pointer-events':'none',
    color:'rgba(0, 0, 0, 0.26)',
    boxShadow: 'none',
    backgroundColor:' rgba(0, 0, 0, 0.12)',
    border:'0px'
  },
  imgPrev: {
    display: 'block',
    overflow: 'hidden',
    width: '97px',
    height: '97px',
    borderRadius: '10px',
  },
  deleteBtn:{
    background:'transparent',
    border:'none',
    padding:'0',
  }

}));


const ImageUploader = ({
  subtitle,
  UploadLimit = 1,
  imageUploadError,
  onSelectImage,
  deleteImage: onDeleteImage,
  isInnovateOneImageOnly,
  isLoader,
  IdForImage,
  images = []
}) => {
  const classes = useStyles()
    const imagesArr = images
    // console.log("🚀 ~ ImageUploader ~ imagesArr:", imagesArr)
  const fileInput = useRef(null);

  const handleUploadImage = async (file) => {

    if (!file) {
      console.error('No file selected.');
      return;
    }

    if (!(file instanceof Blob)) {
      console.error('Selected item is not a Blob or File:', file);
      return;
    }
  
    const reader = new FileReader();
    reader.onload = async (event) => {
      const src = event.target.result;
      const img = {
        name: file.name,
        src,
        key: `${file.name}_${Date.now()}`,
        file,
      };
      await onSelectImage(IdForImage,img);
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteImage = (img) => {
    onDeleteImage(IdForImage,img);
  };

  // const isUploadDisabled = imagesArr.length  >= 1;
  // const isUploadDisabled = (imagesArr?.length || 0) >= UploadLimit;

  const normalizedImagesArr = Array.isArray(imagesArr)
  ? imagesArr
  : typeof imagesArr === 'string'
  ? [{ src: imagesArr, key: imagesArr }]
  : [];



  

  return (
    <div className={classes.root}>
      <NxtCircularLoader isLoading={isLoader}>
      <label htmlFor="upload-input">
        <input
          id="upload-input"
          type="file"
          accept="image/*"
          ref={fileInput}
          onChange={(e) => handleUploadImage(e.target.files[0])}
          // disabled={isUploadDisabled}
          className={classes.input}
        />
        <div
          className={`${classes.add_image} `}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => {
            e.preventDefault();
            handleUploadImage(e.dataTransfer.files[0]);
          }}
        >
          <img src={uploadIcon} alt="upload" className={classes.upload_icon} />
          <div className={classes.upload_media_help_text_1}>{subtitle}</div>
        </div>
      </label>
</NxtCircularLoader>
      {imageUploadError && <p className={classes.error}>*{imageUploadError}</p>}

      <div className={classes.imgblock}>
        {normalizedImagesArr.length > 0 &&
          normalizedImagesArr.map((image) => (
            <ImageItem
              classes={classes}
              key={image.key || image.src}
              image={image}
              onDeleteButton={() => handleDeleteImage(image)}
              usingDelete
            />
          ))}
      </div>

      {/* <div className={classes.imgblock}>
        {imagesArr?.length > 0 && imagesArr?.map((image) => (
            <ImageItem
              classes={classes}
              key={image.key}
              image={image}
              onDeleteButton={() => handleDeleteImage(image)}
              usingDelete
            /> 
          
        ))} 
      </div> */}

    </div>
  );
};

export default ImageUploader;
